// extracted by mini-css-extract-plugin
export default {"drawingCursor":"game-draw_drawingCursor__7VUu7","erasingCursor":"game-draw_erasingCursor__weRvi"};